import { Address, L1ChainId, TokenSymbol } from '../../types'
import { useSupportChains } from '../../store/app/hooks'
import { useSpotCurrencies } from '../../store/market/hooks'
import { useMemo } from 'react'

export function useTokenListByChainId(l1ChainId: L1ChainId): Array<{
  id: number
  name: string // token name in zkex, uppercase
  l2CurrencyId: number
  l2Symbol: TokenSymbol // token symbol in zklink， strict case, e.g. wETH
  address: Address
  decimals: number
}> {
  const supportChains = useSupportChains()
  const currencies = useSpotCurrencies()

  return useMemo(() => {
    const { layerTwoChainId = 0 } =
      supportChains.find((chain) => chain.layerOneChainId === l1ChainId) ?? {}
    if (!layerTwoChainId) {
      return []
    }

    return currencies
      .filter((v) => v.chains && v.chains[layerTwoChainId])
      .map((v) => {
        return {
          id: v.id,
          name: v.name,
          l2CurrencyId: v.l2CurrencyId,
          l2Symbol: v.l2Symbol,
          address: v.chains[layerTwoChainId].address,
          decimals: v.chains[layerTwoChainId].decimals,
        }
      })
  }, [supportChains, l1ChainId])
}
